module.exports = __webpack_public_path__ + "img/fig41.38c8b0ff.jpg";